import { Command as CommandPrimitive, useCommandState } from "cmdk";

export interface SelectListLoadingMoreProps {
  loading: boolean;
  loadingText: string;
}

/** A loading row trailing the options while more results load; the empty row covers loading with no options showing. */
export const SelectListLoadingMore = ({ loading, loadingText }: SelectListLoadingMoreProps) => {
  const hasVisibleItems = useCommandState((state) => state.filtered.count > 0);
  if (!loading || !hasVisibleItems) return null;

  return (
    <CommandPrimitive.Loading
      data-slot="select-loading"
      label={loadingText}
      className="px-2 py-1.5 text-sm text-muted-foreground"
    >
      {loadingText}
    </CommandPrimitive.Loading>
  );
};
